

































import { Component, Vue } from 'vue-property-decorator';
import CommonUtils from '@/utils/common-utils';

@Component
export default class Signup extends Vue {
  signUp() {
    CommonUtils.doSignUp();
  }
}
